import axios from 'axios';

const BASE = process.env.REACT_APP_BASE_URL;

export const getURLShorten = (genetatedUrl: string) =>
  axios.post(`${BASE}/api/shorten-url`, { url: genetatedUrl });
